// src/features/branch/branchSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchBranchMaster } from './branchThunks';


const initialState = {
    branches: [],
    loading: false,
    error: null,
};

const branchSlice = createSlice({
    name: 'branch',
    initialState,
    reducers: {
        // Add any sync reducers here if needed
        // Add any sync reducers here if needed
        setBranches: (state, action) => {
            console.log(action, "action in vender masyere jnj")
            state.branches = action.payload;
            state.loading = false;
            state.error = null;
        },
        setBranchesLoading: (state) => {
            state.loading = true;
        },
        setBranchesError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        resetBranches: () => initialState, // 🔁 Reset to initial state

    },


    // THIS FUNCTION USED FOR createAsyncThunk **REACT QUERY V5 IS BEST FOR createAsyncThunk **
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranchMaster.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBranchMaster.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = action.payload;
            })
            .addCase(fetchBranchMaster.rejected, (state, action) => {
                state.loading = false;
                state.msg = "errorr "
                state.error = action.payload || action.error.message;
            });
    },
});
export const { setBranches, setBranchesLoading, setBranchesError, resetBranches } = branchSlice.actions;

export default branchSlice.reducer;
